export default "__VITE_ASSET__6f2958ea__"